export const TANK_TYPES = [
  {
    label: 'Fire Guard',
    value: 'fire_guard',
  },
  {
    label: 'Single Wall',
    value: 'single_wall',
  },
  {
    label: 'Double Wall',
    value: 'double_wall',
  },
  {
    label: 'Overhead',
    value: 'overhead',
  },
  {
    label: 'Trans Cube',
    value: 'trans_cube',
  },
  {
    label: 'Fuel Cube',
    value: 'fuel_cube',
  },
  {
    label: 'Standard',
    value: 'standard',
  },
  {
    label: 'Round',
    value: 'round',
  },
  {
    label: 'Farm',
    value: 'farm',
  },
  {
    label: 'Kicker',
    value: 'kicker',
  },
  {
    label: 'Convault',
    value: 'convault',
  },
  {
    label: 'Frac',
    value: 'frac',
  },
  {
    label: 'Square Tank',
    value: 'square_tank',
  },
  {
    label: 'Super Vault',
    value: 'super_vault',
  },
  {
    label: 'Trailer',
    value: 'trailers',
  },
  {
    label: 'Vertical',
    value: 'vertical',
  },
];

export const TANK_TYPES_NAME_VALUE: Record<string, string> = {
  fire_guard: 'Fire Guard',
  single_wall: 'Single Wall',
  double_wall: 'Double Wall',
  overhead: 'Overhead',
  trans_cube: 'Trans Cube',
  fuel_cube: 'Fuel Cube',
  standard: 'Standard',
  round: 'Round',
  farm: 'Farm',
  kicker: 'Kicker',
  convault: 'Convault',
  frac: 'Frac',
  square_tank: 'Square Tank',
  super_vault: 'Super Vault',
  trailers: 'Trailer',
  vertical: 'Vertical',
};
